<template>
  <div>
    <search-bar :backgroundColorGray="true"></search-bar>

    <section>
      <div class="container">
        <h1 class="text-center text-md-left">Dicas</h1>

        <div class="row mt-3">
          <div class="col-lg-3 col-md-4 col-sm-6 mb-5" v-for="video in videos">

            <div class="video">
              <iframe
                :src="video.embed_link"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div>{{video.title}}</div>
          </div>
        </div>

        <div>
          <a href="#" class="btn btn-primary btn-block" @click="loadMore">Carregar mais</a>
        </div>
      </div>
    </section>

    <div class="diagonal-line"></div>
  </div>
</template>

<script>
import VideoAPI from "@/api/video";
import SearchBar from "@/components/SearchBar.vue";

export default {
  components: { SearchBar },
  data() {
    return {
      videos: [],
      count: 8
    };
  },
  async mounted() {
    await this.loadVideos();

  },
  methods: {
    async loadVideos() {
      this.videos = await VideoAPI.get(this.count);
    },
    loadMore() {
      this.count += 8;
      this.loadVideos();
    }
  }
};

</script>





// WEBPACK FOOTER //
// src/pages/Tips.vue